<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">最新报告</div>
          <span class="m-title-s">对最新报告操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>最新报告列表
            <span style="font-size: 14px;margin-left: 20px;color: #ff4d51;">(最新报告取列表最新创建的前2项显示在app内)</span>
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增最新报告</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="parentName" label="所属栏目" width=""></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" ref="form" label-width="125px">
            <el-form-item label="选择报告: " prop="parentName">
              <el-input v-model="form.articleName" :id="form.articleId" placeholder="点击右侧按钮" disabled>
                <el-button type="primary" slot="append"  @click="tree = true">选择上级菜单</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
      <!-- 选择树 -->
      <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" center append-to-body>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :data="dataListOpt"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :filter-node-method="filterNode"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
        </el-tree>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'articleNew',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      form: {
        id: '',
        articleId: '',
        articleName: ''
      },
      tree: false,
      filterText: '',
      dataListOpt: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      }
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    selectMenu (e) {
      this.tree = false
      this.form.articleName = e.target.parentElement.name
      this.form.articleId = e.target.parentElement.value
    },
    closeDialog: function () {
      this.form = {
        id: '',
        articleId: '',
        articleName: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      _this.formLoading = true
      this.$axios.post('/articleNew/save', _this.form)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.listData()
            _this.openState = false
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.formLoading = false
          }
        })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/articleNew/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 报告列表
    loadArticleList () {
      let _this = this
      this.$axios.post('/article/list')
        .then((res) => {
          _this.dataListOpt = res.data
        })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/articleNew/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
    this.loadArticleList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/article/ArticleNew.vue